import React, { useMemo, memo } from 'react';
import PropTypes from 'prop-types';
import arePropsEqual from 'react-fast-compare';
import GameCardsLine from '../GameCardsLine';
import { useQueryGames } from '../../../hooks/API/useQueryGames';
import { getProviderDetailRoute } from '../../../utils/routes';
import { getGames } from '../utils';
import { getDataTestAttrs } from '../../../utils/testing-locators';
import { PROVIDER_GAMES_LIST } from '../../../constants/dataTestIds';
import { ANALYTICS_SCREEN_AREA_DETAILS } from '../../../constants/analytics';

const GameCardsLineProvider = ({
  providerId,
  limit,
  excludeGameIds,
  className,
  analyticsData,
  ...props
}) => {
  const { isLoading, data } = useQueryGames(
    {
      _limit: limit,
      provider: providerId,
    },
    { enabled: Boolean(providerId) }
  );

  const items = useMemo(() => {
    const games = data?.items ?? [];
    return getGames(games, excludeGameIds);
  }, [data, excludeGameIds]);

  return (
    <GameCardsLine
      items={items}
      isLoading={isLoading}
      className={className}
      analyticsData={{
        ...analyticsData,
        provider_id: providerId,
        screen_area_detail: ANALYTICS_SCREEN_AREA_DETAILS.OTHER_PROVIDERS_GAME,
      }}
      link={getProviderDetailRoute(providerId)}
      {...getDataTestAttrs(PROVIDER_GAMES_LIST, providerId)}
      {...props}
    />
  );
};

GameCardsLineProvider.propTypes = {
  providerId: PropTypes.string,
  limit: PropTypes.number,
  excludeGameIds: PropTypes.arrayOf(PropTypes.string),
  analyticsData: PropTypes.shape({
    screen_name: PropTypes.string,
    screen_area: PropTypes.string,
  }),
};

GameCardsLineProvider.defaultProps = {
  limit: 16,
  excludeGameIds: [],
  analyticsData: {},
};

export default memo(GameCardsLineProvider, arePropsEqual);
